import { render, staticRenderFns } from "./InputWithTextareaModal.vue?vue&type=template&id=638e3327&scoped=true"
import script from "./InputWithTextareaModal.vue?vue&type=script&lang=ts"
export * from "./InputWithTextareaModal.vue?vue&type=script&lang=ts"
import style0 from "./InputWithTextareaModal.vue?vue&type=style&index=0&id=638e3327&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638e3327",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('638e3327')) {
      api.createRecord('638e3327', component.options)
    } else {
      api.reload('638e3327', component.options)
    }
    module.hot.accept("./InputWithTextareaModal.vue?vue&type=template&id=638e3327&scoped=true", function () {
      api.rerender('638e3327', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/InputWithTextareaModal.vue"
export default component.exports